var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMarketIndex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.439,
    height: 20.649
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2191"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2190",
    transform: "translate(-7619.976 -1453.202)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4380",
    d: "M7620.476 1463.543h5.912l1.79 2.422 2.36-2.422 1.557 4.917 3.031-10.431 1.565 5.514h5.436",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 105",
    cx: 0.549,
    cy: 0.549,
    r: 0.549,
    transform: "translate(7643.808 1462.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 106",
    cx: 0.549,
    cy: 0.549,
    r: 0.549,
    transform: "translate(7646.005 1462.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 107",
    cx: 0.549,
    cy: 0.549,
    r: 0.549,
    transform: "translate(7648.203 1462.985)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2192",
    fill: "#00b8f1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4381",
    d: "M.071 7.806v.018a.746.746 0 001.492 0h.008V1.5h26.366v6.324h.008a.744.744 0 001.488 0V1.25A1.251 1.251 0 0028.183 0H1.321a1.251 1.251 0 00-1.25 1.25v6.544z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4382",
    d: "M28.689 12.044a.75.75 0 00-.75.75c0 .011.005.019.006.03h-.008v6.325H1.571v-6.325h-.008c0-.011.006-.019.006-.03a.75.75 0 00-1.5 0c0 .011 0 .019.006.03v6.575a1.251 1.251 0 001.25 1.25h26.862a1.251 1.251 0 001.25-1.25v-6.575c0-.011.006-.019.006-.03a.75.75 0 00-.754-.75z"
  })))));
}

export default SvgIconMarketIndex;